export const HEALTH_STATUS_SCORE = {
  critical: 9,
  critical_na: 8,
  alarm: 7,
  alarm_na: 6,
  monitor: 5,
  monitor_na: 4,
  healthy: 3,
  healthy_na: 2,
  na: 1,
  na_na: 0,
};
